import { AdminActiveDirectoriesSliceStateInterface } from 'store/reducers/adminActiveDirectories/types';

export const initialAdminActiveDirectoriesStoreState: AdminActiveDirectoriesSliceStateInterface = {
  activeDirectoriesData: {
    adminActiveDirectoriesList: [],
    loading: false,
  },
  activeDirectorInfo: null,
};
